import { Tag, Timeline, Alert } from "antd"
import moment from "moment"

const ApprovalInfoSection = ({ details, approvalProcess, isStrict }) => {
  if (!details || details.length === 0) return null

  const getApprovalDateLabel = item => {
    const approvedAt = item?.approved_time || item?.approved_at || null
    const rejectedAt = item?.rejected_time || item?.rejected_at || null

    if (item?.rejected && item?.status) {
      return rejectedAt ? `Rejected at ${moment(rejectedAt).format("dddd, DD MMMM YYYY, HH:mm")}` : "Rejected"
    }

    if (item?.status) {
      return approvedAt ? `Approved at ${moment(approvedAt).format("dddd, DD MMMM YYYY, HH:mm")}` : "Approved"
    }

    return "Waiting Approval"
  }

  const renderBadgeType = (rejected, status) => {
    if (!rejected && status) {
      return "success"
    } else if (rejected && status) {
      return "error"
    } else {
      return "warning"
    }
  }

  return (
    <div className="approval-info-section">
      <label
        style={{
          fontSize: 15,
          fontWeight: "bold",
          marginBottom: 12,
          display: "block",
        }}
      >
        Approval Process ({approvalProcess || "Concurrent"})
        {isStrict && (
          <Tag color="red" style={{ marginLeft: 8, verticalAlign: "middle" }}>
            Strict
          </Tag>
        )}
      </label>
      <Timeline style={{ marginTop: 30 }}>
        {details.map(item => (
          <Timeline.Item key={item._id}>
            {item.approver?.fullname} - {item?.approver?.nik}
            <Alert message={getApprovalDateLabel(item)} className="mt-2 p-1" type={renderBadgeType(item.rejected, item.status)} showIcon />
          </Timeline.Item>
        ))}
      </Timeline>
    </div>
  )
}

export default ApprovalInfoSection
